import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postInsuranceType } from "../../store/insuranceType/actions";
export var useInsuranceTypeCreate = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responsePostInsuranceType: state.InsuranceType.responsePostInsuranceType,
        errorPostInsuranceType: state.InsuranceType.errorPostInsuranceType,
        loadingPostInsuranceType: state.InsuranceType.loadingPostInsuranceType,
    }); }), responsePostInsuranceType = _a.responsePostInsuranceType, errorPostInsuranceType = _a.errorPostInsuranceType, loadingPostInsuranceType = _a.loadingPostInsuranceType;
    useEffect(function () {
        if (trigger) {
            dispatch(postInsuranceType(body));
        }
    }, [trigger]);
    return {
        responsePostInsuranceType: responsePostInsuranceType,
        errorPostInsuranceType: errorPostInsuranceType,
        loadingPostInsuranceType: loadingPostInsuranceType,
    };
};
